<template>
  <div>
    <!-- 新闻-->
    <div
      class="container w-1200 d-flex j-sb a-center"
      @click="openBrandNewsDetail(news.location)"
      v-for="(news, index) in newList"
      :key="index"
    >
      <div class="banner_box">
        <img
          :src="news.img"
          alt=""
          style="width: 100%; vertical-align: middle"
        />
      </div>
      <p
        style="
          margin-left: 30px;
          font-size: 28px;
          color: #333;
          height: 262px;
          width: 810px;
          line-height: 1.75em;
        "
        class="d-flex a-center"
      >
        <span>
          {{ news.title }}
        </span>
      </p>
    </div>

    <div style="height: 400px" v-if="newList.length < 2"></div>
    <div style="height: 100px" v-else></div>
    <!-- 底部栏 -->
    <foot />
  </div>
</template>
<script>
import image from "../assets/newsbanner.png";
export default {
  data() {
    return {
      newList: [
        {
          img: image,
          location: "/BrandNewsDetail",
          title:
            "【重磅发布】来自世界品牌论坛发起的认证，Tetra德彩三度荣膺德国“世纪品牌奖”",
        },
        {
          img: image,
          location: "/TetraNews",
          title: "Tetra® 德彩品牌简介",
        },
        {
          img: image,
          location: "/SmartbonesNews",
          title: "Smartbones品牌介绍",
        },
        {
          img: image,
          location: "/FURminatorNews",
          title: "富美内特品牌介绍",
        },
        {
          img: image,
          location: "/CompetitionNews",
          title: "德彩 | 创造无限可能，造景大师齐聚德彩总部，上演巅峰对决！",
        },
        {
          img: image,
          location: "/Instructions",
          title: "Tetra EX Plus 外置过滤器-使用说明书",
        }
      ],
    };
  },
  methods: {
    openBrandNewsDetail(location) {
      this.$router.push(location);
    },
  },
};
</script>
<style lang="scss" scoped>
.d-flex {
  display: flex;
}
.a-center {
  align-items: center;
}
.j-sb {
  justify-content: space-between;
}
.j-center {
  justify-content: center;
}
.w-1200 {
  width: 1200px;
  margin: 0 auto;
}

.container {
  margin-top: 30px;
  padding-bottom: 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #f5f5f5;

  &:hover {
    background-color: #f6f7f8;
    cursor: pointer;
  }
  .banner_box {
    width: 350px;
    height: 262px;
  }
}
</style>